import { Box, Skeleton } from '@mui/material';
import {
  CheckboxSkeleton,
  CheckboxTextSkeleton,
} from 'components/SkeletonLoaders';

const Button = () => <Skeleton
  height={65} width={225}
/>;
const SkeletonLoader = ({ isMinor }) => {
  return (
    <Box>
      <Box
        sx={{ marginTop: '38px', display: 'flex', gap: '10px' }}>
        <CheckboxSkeleton />
        <CheckboxTextSkeleton />
      </Box>
      <Box
        sx={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
        <CheckboxSkeleton />
        <CheckboxTextSkeleton />
      </Box>
      <Box
        sx={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
        <CheckboxSkeleton />
        <CheckboxTextSkeleton />
      </Box>
      <Box
        sx={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
        <CheckboxSkeleton />
        <CheckboxTextSkeleton />
      </Box>
      {isMinor && (
        <Box
          sx={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
          <CheckboxSkeleton />
          <CheckboxTextSkeleton />
        </Box>
      )}
      <Box
        sx={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
        <Button />
        <Button />
      </Box>
    </Box>
  );
};

export default SkeletonLoader;
